"use strict";

angular.module("core")
.service("CoreProductVariantService", function($resource, $filter) {
    this.getProductVariantName = function(variantOptions, optionValues) {
        if (!variantOptions) {
            return "";
        }
        var variantNames = [];
        angular.forEach(variantOptions, function(option) {
            angular.forEach(optionValues, function(optionValue) {
                angular.forEach(option.values, function(value) {
                    if (optionValue === value.id) {
                        variantNames.push($filter("localizedField")(value.name));
                    }
                });
            });
        });
        return variantNames.join(' / ');
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/product-variants/core-product-variant.service.js
// module id = 450
// module chunks = 0